import { mapState } from "vuex";

export default {
	computed: {
		...mapState("flight", {
			isFlight: state => state.isFlight,
			crewExist: state => state.crewExist,
			isUpgrade: state => state.isUpgrade,
			isFoodMenu: state => state.isFoodMenu,
			isService: state => state.isService,
			flightInfo: (state) => state.flightInfo,
			flightPath: (state) => state.flightPath,
			airports: (state) => state.airports,
			serverTime: (state) => state.serverTime,
			// mapData: (state) => state.mapData
		}),
		...mapState("user", {
			isAuth: state => state.authenticate
		}),
		...mapState("settings", {
			isIfc: state => state.IFC_EXISTS,
			isBox: state => state.isBox
		}),
		createIconPath() {
			if (this.flightInfo.weather.icon.lastIndexOf(".")) {
				return require('@/assets/weather/' + (this.flightInfo.weather.icon).substring(0, this.flightInfo.weather.icon.lastIndexOf(".")) + ".svg");
			} else {
				return require('@/assets/weather/' + this.flightInfo.weather.icon + ".svg");
			}
		},

	},
	methods: {
		mutateCode(item) {
			let locale = this.$i18n.locale.toLowerCase();
			let responseObject = {};
			let locales = ["en", "ru", "zh", "fr", "de", "it", "es", "ja", "ko"];
			let keys = ["city", "code", "country", "name"];
			for (let i = 0; i < locales.length; i++) {
				keys.forEach(it => {
					if (item[locales[i]][it]) {
						responseObject[it] = item[locales[i]][it];
					}
				});
			}
			keys.forEach(it => {
				if (item[locale][it]) {
					responseObject[it] = item[locale][it];
				}
			});

			return responseObject;
		},
		mutateKeyLang(item, key) {
			return (
				item[key + "_" + this.$i18n.locale.toUpperCase()] ||
				item[key + this.$i18n.locale.toUpperCase()]
			);
		},
		getTimeFromDate(date) {
			if (date) {
				let curDate = new Date(date);
				let hours = curDate.getHours();
				let minutes = this.getNumberLessten(curDate.getMinutes());
				let time = `${hours}:${minutes}`;
				return time;
			} else {
				return "00:00"
			}
		},
		getNumberLessten(num) {
			if (num == 0) {
				return '00'
			} else if (num < 10) {
				return '0' + num
			} else {
				return num
			}
		},
		normaliseDate(date) {
			if(date){
				const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
				// let normDate = date;
				let day = new Date(date).getDate();
				let month = monthNames[new Date(date).getMonth()];
				let year = new Date(date).getFullYear();
				return `${day} ${month} ${year}`;
			} else {
				return ""
			}
		},
		// msToTime(arrivalTime, currentTime) {
		//   let duration = this.formateDateToMillisecond(arrivalTime) - currentTime;
		//   // var milliseconds = parseInt((duration % 1000) / 100),
		//   // seconds = parseInt((duration / 1000) % 60),
		//   let minutes = parseInt((duration / (1000 * 60)) % 60);
		//   let hours = parseInt((duration / (1000 * 60 * 60)) % 24);

		//   hours = (hours < 10) ? "0" + hours : hours;
		//   minutes = (minutes < 10) ? "0" + minutes : minutes;
		//   // seconds = (seconds < 10) ? "0" + seconds : seconds;
		//   this.timeLeft = hours + "часа" + minutes + "минут";
		//   console.log(this.timeLeft)
		// },
		getTimeZoneFromDate(date) {
			if (date) {
				let zoneSumbol = date.split("Z").pop().substring(0, 1);
				let timeShift = parseInt(date.split("Z").pop().substring(1, 3))
				return `${zoneSumbol}${timeShift}`
			} else {
				return ""
			}
		},
		getTimeZone(date) {
			return +date.split("+").pop().split(":").shift()
		},
		hoursToMillisecond(hours) {
			return hours * 60 * 60 * 1000
		},
		checkFlyingTime() {
			this.flyPercent = this.getCurrentFlyingPercent(this.formateDateToMillisecond(this.serverTime.split(".").shift()), this.flightInfo.legs[0].depTimeFact, this.flightInfo.legs[0].arrTimeFact);
			if (this.flyPercent > 100) {
				this.flyPercent = 100;
				return
			} else if (this.flyPercent < 0) {
				this.flyPercent = 0;
				return
			}
			this.currentTime = this.formateDateToMillisecond(this.serverTime.split(".").shift());
			this.intervalid = setInterval(() => {
				this.flyPercent = this.getCurrentFlyingPercent(this.currentTime, this.flightInfo.legs[0].depTimeFact, this.flightInfo.legs[0].arrTimeFact);
				// this.msToTime(this.flightInfo.legs[0].arrTimeFact, this.currentTime);
				this.currentTime = this.currentTime + 10000;
				// console.log(new Date(this.currentTime))
			}, 10000);
		},
		checkFlyingTime2() {
			this.flyPercent2 = this.getCurrentFlyingPercent(this.formateDateToMillisecond(this.serverTime.split(".").shift()), this.flightInfo.legs[0].depTimeFact, this.flightInfo.legs[0].arrTimeFact);
			if (this.flyPercent2 > 100) {
				this.flyPercent2 = 100;
				return
			} else if (this.flyPercent2 < 0) {
				this.flyPercent2 = 0;
				return
			}
			this.currentTime2 = this.formateDateToMillisecond(this.serverTime.split(".").shift());
			this.intervalid2 = setInterval(() => {
				this.flyPercent2 = this.getCurrentFlyingPercent(this.currentTime2, this.flightInfo.legs[0].depTimeFact, this.flightInfo.legs[0].arrTimeFact);
				this.currentTime2 = this.currentTime2 + 60000;
			}, 60000);
		},
		formateDateToMillisecond(date) {
			return Date.parse(date);
		},
		setHoursMinutesFromMS(time) {
			this.flyingHours = Math.floor((time / (1000 * 60 * 60)) % 24);
			this.flyingMinutes = Math.floor((time / (1000 * 60)) % 60);
			// console.log( this.flyingMinutes)
			// console.log(this.flyingHours);
			// console.log(this.flyingMinutes);
		},
		getCurrentFlyingPercent(currentTime, departureTime, arrivalTime) {
			let percent = '';
			let totalFlyingTime = this.formateDateToMillisecond(arrivalTime) - this.formateDateToMillisecond(departureTime);
			let currentFlyingTime = currentTime - this.formateDateToMillisecond(departureTime);
			percent = Math.floor(currentFlyingTime / totalFlyingTime * 100);
			this.setHoursMinutesFromMS((totalFlyingTime - currentFlyingTime));
			//   console.log('departureTime:'+ this.formateDateToMillisecond(departureTime))
			//   console.log('currentTime:'+ currentTime);
			//   console.log('arrivalTime:'+ this.formateDateToMillisecond(arrivalTime))
			//   console.log('totalFlyingTime:'+ totalFlyingTime/1000/60/60);
			//   console.log('currentFlyingTime:'+currentFlyingTime/1000/60/60);
			//   console.log('percent:'+percent);
			return percent
		},
		drawFlyingScale() {
			this.flyingHours = Math.floor((this.flightInfo.timeToDestination / (60 * 60)) % 24);
			this.flyingMinutes = Math.floor((this.flightInfo.timeToDestination / 60) % 60);
			this.flyPercent = Math.floor(this.flightInfo.timeSinceTakeoff / (this.flightInfo.timeSinceTakeoff + this.flightInfo.timeToDestination) * 100);

			if (this.flyPercent > 100) {
				this.flyPercent = 100;
				return
			} else if (this.flyPercent < 0) {
				this.flyPercent = 0;
				return
			}

			// console.log(this.flyingHours)
			// console.log(this.flyingMinutes)
			// console.log(this.flyPercent)
		}
	}
};
